import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const comsP1Template = (
  node: HTMLElement,
) => html`<one-paper background="legal-1" padding="sm">${unsafeHTML(node.innerHTML)}</one-paper>`;
